import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const ronyTrades: SeasonTrades[] = [
  {
    season: "2021/22",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "1st round pick (#2) and Bradley Beal",
        gotInReturn: "Stephen Curry and 1st round pick (#11)",
        amongBestTrades: true
      },
      {
        otherTeam: manager.mati,
        sentAway: "Mike Conley",
        gotInReturn: "Will Barton",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Christian Wood",
        gotInReturn: "OG Anunoby",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Alperen Sengun",
        gotInReturn: "Julius Randle and Jae'Sean Tate",
        amongWorstTrades: true,
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Julius Randle",
        gotInReturn: "Chris Duarte",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Jonas Valanciunas",
        gotInReturn: "Jarrett Allen (Out For Season)",
      },
    ],
  },
  {
    season: "2022/23",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "3rd round pick (#25)",
        gotInReturn: "Devin Vassell and 5th round pick"
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Jabari Smith Jr", 
        gotInReturn: "Kristaps Porzingis",
        amongWorstTrades: true
      }
    ]
  },
  {
    season: "2023/24",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Scoot Henderson",
        gotInReturn: "Jabari Smith"
      },
      {
        otherTeam: manager.mati,
        sentAway: "Jarrett Allen and 1st round pick (#2)",
        gotInReturn: "Rudy Gobert, Khris Middleton and 1st round pick (#6)"
      }
    ]
  }
];
